module.exports = __webpack_public_path__ + "static/media/exp.795a350d.png";